<template>
  <section>    
  	<div class="modalsave" v-show="continuarCapa"></div> 
    <b-row > 
      <b-col>
            <validation-observer v-slot="{ invalid } ">     
              <b-card > 
                <template v-slot:header >
                  <div class="header-card">
                    Registrar Aportes
                  </div> 
                </template> 
                
                <b-nav tabs>
                  <b-nav-item :active="active===0" @click="resetDataGet();searchSw.value='';active=0">Afiliado</b-nav-item>
                  <b-nav-item :active="active===1" @click="resetDataGet();searchSw.value='';active=1;"  class="d-none d-md-block">Centro de trabajo</b-nav-item>
                  <b-nav-item :active="active===2" @click="resetDataGet();searchSw.value='';active=2;"  class="d-none d-md-block">Razón Social</b-nav-item>
                  <b-nav-item :active="active===3" @click="resetDataGet();searchSw.value='';active=3;"  class="d-none d-md-block">Asesor</b-nav-item>
                </b-nav>  
                <div  style="border:1px solid; border-top:none;border-color: #dee2e6;">
                  <br>
                  <!-- Afiliado -->
                    <div v-if="active===0" class="p-1"> 
                      <b-row align-v="center"> 
                          <sw-searchs
                            :md="5"
                            :lg="5"
                            label='Seleccionar afiliado'
                            list='datos_afiliado'
                            @input="searchsData('afiliado')"
                            filterCampos="documento"
                            :filter="[{campo: 'id_list_estado', value: 1},{campo: 'servicios', value: 0}]"
                          >
                          </sw-searchs>  
                          <b-col>
                            <b-button @click="searchSw.value='';" style="margin-top:10px" size="sm">Limpiar</b-button>
                          </b-col>
                      </b-row> 
                      <div  v-if="searchSw.value!='' && dataForm[namePath].servicios_activos.length>0  " >
                        <b-row class="p-2">
                          <sw-inputs
                            inputTabla="info_afiliacion"
                            inputCampo="id_list_novedad"
                            @input="changeNovedad"
                            :md="2" :lg="2">
                          </sw-inputs>                           
                          <b-col :md="12" :lg="12" v-if="windowSize<992 && (dataForm[namePath].info_afiliacion.id_list_novedad===3 || dataForm[namePath].info_afiliacion.id_list_novedad===1)">
                            <b-row style="background: rgba(0,80,166, 0.03);padding-bottom: 20px">
                                <b-col
                                  :md="4" :lg="4">
                                  <b-form-group
                                    label="Salario proporcional"
                                  >
                                    <b-input-group size="sm" prepend="$">
                                    <vue-numeric v-model="salarioproporcional" separator="."  disabled trim></vue-numeric>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <sw-inputs
                                  v-if="(novedad===1 && dataForm[namePath].info_afiliacion.id_list_novedad===3) || dataForm[namePath].info_afiliacion.id_list_novedad===1 "
                                  inputTabla="info_afiliacion"
                                  inputCampo="ingreso"
                                  @input="changeIngreso"
                                  :md="4" :lg="4">
                                </sw-inputs>                             
                                <sw-inputs
                                  v-if="dataForm[namePath].info_afiliacion.id_list_novedad===3"
                                  inputTabla="info_afiliacion"
                                  inputCampo="retiro"
                                  @input="changeRetiro"
                                  :md="4" :lg="4">
                                </sw-inputs>
                            </b-row>  
                          </b-col>   
                          <sw-inputs
                          inputTabla="info_afiliacion"
                          inputCampo="dias"
                            :md="2" :lg="2">
                          </sw-inputs>     
                          <sw-inputs
                          inputTabla="info_afiliacion"
                          inputCampo="salario"
                          @input="changeSalario"
                            :md="2" :lg="2">
                          </sw-inputs>   
                          <sw-inputs
                          inputTabla="info_afiliacion"
                          inputCampo="id_datos_razon"
                            :md="2" :lg="2">
                          </sw-inputs>                     
                          <sw-inputs
                            inputTabla="info_afiliacion"
                            inputCampo="id_datos_asesor"
                            :md="2" :lg="2">
                          </sw-inputs>
                          <sw-inputs
                            inputTabla="info_afiliacion"
                            inputCampo="id_datos_contacto"
                            :md="2" :lg="2">
                          </sw-inputs>  
                          <b-col :md="12" :lg="12" v-if="windowSize>=992 && (dataForm[namePath].info_afiliacion.id_list_novedad===3 || dataForm[namePath].info_afiliacion.id_list_novedad===1)">
                            <b-row style="background: rgba(0,80,166, 0.03);padding-bottom: 20px">
                                <b-col
                                  :md="4" :lg="4">
                                  <b-form-group
                                    label="Salario proporcional"
                                  >
                                    <b-input-group size="sm" prepend="$">
                                    <vue-numeric v-model="salarioproporcional" separator="."  disabled trim></vue-numeric>
                                    </b-input-group>
                                  </b-form-group>
                                </b-col>
                                <sw-inputs
                                  v-if="(novedad===1 && dataForm[namePath].info_afiliacion.id_list_novedad===3) || dataForm[namePath].info_afiliacion.id_list_novedad===1 "
                                  inputTabla="info_afiliacion"
                                  inputCampo="ingreso"
                                  @input="changeIngreso"
                                  :md="4" :lg="4">
                                </sw-inputs>                             
                                <sw-inputs
                                  v-if="dataForm[namePath].info_afiliacion.id_list_novedad===3"
                                  inputTabla="info_afiliacion"
                                  inputCampo="retiro"
                                  @input="changeRetiro"
                                  :md="4" :lg="4">
                                </sw-inputs>
                            </b-row>  
                          </b-col>    
                        </b-row> 
                        <b-alert show variant="warning" v-if="dataForm[namePath].servicios_nuevos.length>0">El afiliado tiene los servicios de {{pendientesAfiliado(dataForm[namePath].servicios_nuevos)}} pendientes del radicado de afiliación.</b-alert>
                        <b-alert show variant="danger" v-if="info_incapacidades>0 && dataForm[namePath].info_afiliacion.id_list_novedad===3">El afiliado tiene incapacidades pendientes.</b-alert> 
                        <b-row > 
                          <b-col :md="5"  v-if="windowSize>=992">
                              <h5 class="title-form">Datos Afiliado</h5>
                              <b-row align-v="start"> 
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="info_afiliacion"
                                inputCampo="id_list_tipo"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="info_afiliacion"
                                inputCampo="id_list_subtipo"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="datos_afiliado"
                                inputCampo="id_list_documento"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="datos_afiliado"
                                inputCampo="documento"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="datos_afiliado"
                                inputCampo="nombre1"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="datos_afiliado"
                                inputCampo="nombre2"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="datos_afiliado"
                                inputCampo="apellido1"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="datos_afiliado"
                                inputCampo="apellido2"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="datos_afiliado"
                                inputCampo="direccion"
                                :md="12" :lg="12">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="datos_afiliado"
                                inputCampo="ciudad"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                inputTabla="datos_afiliado"
                                inputCampo="telefonos"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                style="margin-top:8px"
                                inputTabla="info_afiliacion"
                                inputCampo="exonerado"
                                :md="6" :lg="6">
                                </sw-inputs>
                                <sw-inputs
                                class="aporteDatosAfiliado"
                                style="margin-top:8px"
                                inputTabla="datos_afiliado"
                                inputCampo="planilla"
                                :md="6" :lg="6">
                                </sw-inputs>
                              </b-row>
                          </b-col> 
                          <b-col :md="7"  v-if="searchSw.value!='' && dataForm[namePath].servicios_activos.length>0">
                              <h5 class="title-form">Servicios</h5>  
                              <sw-tablemultiple
                                  v-if="dataForm[namePath].info_afiliacion.id_list_novedad===1"
                                  getTable="multiple_servicios"
                                  :hideServicio="['Traslado']"
                                  :views="[
                                    { th:'Select.', td: 'check'},
                                    { th:'Servicio', td: 'name'},
                                    { th:'Entidad', td: 'id_list'},
                                    { th:'1r Aporte', td: 'valoringreso'},
                                  ]"
                                  >
                                </sw-tablemultiple>
                              <sw-tablemultiple
                                  v-if="dataForm[namePath].info_afiliacion.id_list_novedad===2 || dataForm[namePath].info_afiliacion.id_list_novedad===4"
                                  getTable="multiple_servicios"
                                  :hideServicio="['Traslado']"
                                  :views="[
                                    { th:'Select.', td: 'check'},
                                    { th:'Servicio', td: 'name'},
                                    { th:'Entidad', td: 'id_list'},
                                    { th:'Valor', td: 'valor'},
                                  ]"
                                  >
                                </sw-tablemultiple>   
                              <sw-tablemultiple
                                  v-if="dataForm[namePath].info_afiliacion.id_list_novedad===3"
                                  getTable="multiple_servicios"
                                  :hideServicio="['Traslado']"
                                  :views="[
                                    { th:'Select.', td: 'check'},
                                    { th:'Servicio', td: 'name'},
                                    { th:'Entidad', td: 'id_list'},
                                    { th:'Valor', td: 'valorretiro'},
                                  ]"
                                  >
                                </sw-tablemultiple>                     
                          </b-col>   
                        </b-row>
                        <b-col  class="card-footer">
                          <b-row>
                            <b-col :md="6" :lg="6" >
                              <div v-if="errorsAportes().length>0">
                                <p  class="text-danger p-0 m-0" v-for="(item,index) in errorsAportes()" :key="'errors'+index">* {{item.name}}</p> 
                              </div>
                            </b-col>
                            <b-col
                              :md="2"
                              :lg="2">
                              <b-form-group
                                label="Mes Aporte"
                              >
                                <c-multiselect
                                  style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                  v-model="mesPeriodo"                   
                                  :options="lists.list_mes"
                                  label="name"
                                  track-by="name"
                                  :allow-empty="false"
                                  placeholder="Seleccionar"
                                  >
                                </c-multiselect>
                              </b-form-group>
                            </b-col>
                            <b-col
                              :md="2"
                              :lg="2">
                              <b-form-group
                                label="Año Aporte"
                              >
                                <c-multiselect
                                  style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                  v-model="anoPeriodo"                   
                                  :options="lists.list_ano"
                                  label="name"
                                  track-by="name"
                                  :allow-empty="false"
                                  placeholder="Seleccionar"
                                  >
                                </c-multiselect>
                              </b-form-group>
                            </b-col>
                            <b-col :lg="2" :md="2" style="padding-top:25px"> 
                              <b-button id="link-button" size="sm"  class="mt-2" variant="primary" tabindex="0" :disabled="invalidNovedad()" @click="continuarCapa=!continuarCapa">
                                Continuar
                              </b-button>
                              <b-popover target="link-button" :show="continuarCapa" placement="topright" >  
                                <template v-slot:title>
                                  <div class="text-right">
                                    <span class="d-none d-lg-block"  style="float:left">Historial</span>
                                    <span class="mr-5" :class="(dataForm[namePath].info_afiliacion.id_list_novedad!==3) ? 'text-secondary' : 'text-danger' ">{{gettersDatalist('list_novedad',dataForm[namePath].info_afiliacion.id_list_novedad)[0].name}} {{dataForm[namePath].info_afiliacion.dias}} días</span> <span :class="(mesPeriodo.id===fecha().fecha.mesHoy && anoPeriodo.id===fecha().fecha.anoHoy) ? 'text-secondary' : 'text-danger'" style="float:right">{{mesPeriodo.name}} {{anoPeriodo.name}} </span> 
                                  </div>
                                </template> 
                                <b-row>                                  
                                  <b-col class="d-none d-lg-block" style="min-width:450px">
                                    <table  class="table table-stripe">
                                      <thead class="thead-light">
                                        <tr>
                                          <th>Novedad</th>
                                          <th>Fecha</th>
                                          <th>Valor</th>
                                          <th>Periodo</th>
                                          <th>Razón</th>
                                        </tr>
                                      </thead>
                                      <tbody>
                                        <tr v-for="(items,index) in historial" :key="'historial-afilaido'+index">
                                          <td>{{(items.id_list_novedad) ?gettersDatalist('list_novedad',items.id_list_novedad)[0].name : 'Afiliación'}}</td>
                                          <td>{{items.fecha}}</td>
                                          <td>{{items.valor}}</td>
                                          <td>{{(items.mes_periodo) ? items.mes_periodo+'-'+items.ano_periodo : null}}</td>
                                          <td>{{gettersDatalist('datos_razon',items.id_datos_razon)[0].name}}</td>
                                        </tr>
                                      </tbody>

                                    </table>                                    
                                  </b-col>
                                  <b-col style="min-width: 320px;">
                                    <b-alert show class="text-center">{{gettersDatalist('datos_razon',dataForm[namePath].info_afiliacion.id_datos_razon)[0].name}}</b-alert>
                                    <b-list-group>                            
                                      <b-list-group-item v-for="(items,index) in dataMultiple[namePath].multiple_servicios" :key="'activos_servicios'+index" v-show="items.check" >{{items.name}} <span v-if="items.name_list!=null">{{gettersDatalist(items.name_list,items.id_list)[0].name}}</span> 
                                      <span class="ml-4" style="float:right" v-if="dataForm[namePath].info_afiliacion.id_list_novedad===1">{{formatMoney(items.valoringreso)}}</span>
                                      <span class="ml-4" style="float:right" v-if="dataForm[namePath].info_afiliacion.id_list_novedad===2 || dataForm[namePath].info_afiliacion.id_list_novedad===4">{{formatMoney(items.valor)}}</span>
                                      <span class="ml-4" style="float:right" v-if="dataForm[namePath].info_afiliacion.id_list_novedad===3">{{formatMoney(items.valorretiro)}}</span>                                  
                                      </b-list-group-item>                                     
                                      <b-list-group-item>Total: <span class="ml-4 font-weight-bold" style="float:right">{{formatMoney(sumarConfirmar())}}</span></b-list-group-item>
                                    </b-list-group>   
                                    <b-alert show variant="danger" class="my-1 p-1" v-for="(item,index) in errorsAportes()" :key="'errorsAlert'+index">
                                      * {{item.name}}                                  
                                    </b-alert>                                  
                                    <sw-saveform
                                    guardarFtn="afiliadoFtn"
                                    :cerrar="true"
                                    :invalid="invalid || invalidNovedad()"
                                    :index="dataIndex[namePath]"
                                    :getBackendData="getBackendData"
                                    @save="saveForm"
                                    @cerrar="continuarCapa=!continuarCapa">
                                    </sw-saveform>
                                  </b-col>                                 
                                </b-row>           
                              </b-popover> 
                               <b-alert
                                  v-if="searchSw.value!=''"
                                  v-model="showAporteRegistrado"
                                  class="position-fixed fixed-bottom m-0 rounded-0"
                                  style="z-index: 2000;"
                                  variant="warning"
                                  dismissible
                                >
                                Ya existe un aporte en <strong>{{gettersDatalist('list_mes',dataForm[namePath].info_afiliacion.mes_periodo)[0].name}}-{{dataForm[namePath].info_afiliacion.ano_periodo}}</strong> registrado al afiliado <strong>{{dataForm[namePath].datos_afiliado.name}}</strong>  por medio de la razón social <strong>{{gettersDatalist('datos_razon',dataForm[namePath].info_afiliacion.id_datos_razon)[0].name}}</strong>  <b-button variant="link" @click="openRegistro">ver registro</b-button>
                              </b-alert>
                            </b-col>
                          </b-row>                                        
                        </b-col>  
                      </div>  
                       <b-alert
                          v-if="searchSw.value!=''"
                          v-model="statusDescargar"
                          class="position-fixed fixed-bottom m-0 rounded-0"
                          style="z-index: 2000;"
                          variant="warning"
                          dismissible
                        >
                          <p v-if="statusDescargar">El afiliado tiene un aporte pendiente por descargar</p>
                      </b-alert>      
                      <sw-loading v-if="searchSw.value!='' && dataForm[namePath].servicios_activos.length===0 && !statusDescargar"></sw-loading>        
                    </div>
                  <!-- Centro de trabajo -->
                    <div v-if="active===1" class="p-1">                 
                      <sw-tableget
                        :alertClass="tableAlertClass"
                        :alertText="tableAlertText"
                        :tableOptions="tableGBoptions"
                        :tableItems="tableGBItems"
                        :tableSearch="tableGBSearch"
                        name="tableGet2"
                        @filtrar="searchsData('centro')"
                        @limpiar="limpiarSearchs"
                        @save="saveForm"
                        >   
                        <template v-slot:filtrar>                          
                          <b-row align-v="center" style="margin-bottom:5px ;background: rgba(0, 80, 166, 0.03);border: 1px ridge;"> 
                              <sw-searchs
                                :md="4"
                                :lg="4"
                                label='Seleccionar Centro de Trabajo'
                                list='datos_contacto'
                                :filter="[{campo: 'id_list_estado', value: 1}]"
                              >
                              </sw-searchs>  
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Mes Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="mesPeriodo"                   
                                    :options="lists.list_mes"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Año Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="anoPeriodo"                   
                                    :options="lists.list_ano"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                          </b-row>    
                        </template>
                        <template v-slot:modal>
                          <sw-modaleditaraportes 
                            v-if="openModal.modal.modal==='Editar'"
                            @save="saveForm"                     
                            >
                          </sw-modaleditaraportes> 
                        </template>   
                        
                      </sw-tableget>            
                    </div>
                  <!-- Razón social -->
                    <div v-if="active===2" class="p-1">                 
                      <sw-tableget
                        :alertClass="tableAlertClass"
                        :alertText="tableAlertText"
                        :tableOptions="tableGBoptions"
                        :tableItems="tableGBItems"
                        :tableSearch="tableGBSearch"
                        name="tableGet2"
                        @filtrar="searchsData('razon')"
                        @limpiar="limpiarSearchs"
                        @save="saveForm"
                        >   
                        <template v-slot:filtrar>                          
                          <b-row align-v="center" style="margin-bottom:5px ;background: rgba(0, 80, 166, 0.03);border: 1px ridge;"> 
                              <sw-searchs
                                :md="4"
                                :lg="4"
                                label='Seleccionar Razón Social'
                                list='datos_razon'
                                :filter="[{campo: 'id_list_estado', value: 1}]"
                              >
                              </sw-searchs>  
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Mes Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="mesPeriodo"                   
                                    :options="lists.list_mes"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Año Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="anoPeriodo"                   
                                    :options="lists.list_ano"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                          </b-row>    
                        </template>
                        <template v-slot:modal>
                          <sw-modaleditaraportes 
                            v-if="openModal.modal.modal==='Editar'"
                            @save="saveForm"                     
                            >
                          </sw-modaleditaraportes> 
                        </template>   
                        
                      </sw-tableget>            
                    </div>
                  <!-- Asesor -->
                    <div v-if="active===3" class="p-1">                 
                      <sw-tableget
                        :alertClass="tableAlertClass"
                        :alertText="tableAlertText"
                        :tableOptions="tableGBoptions"
                        :tableItems="tableGBItems"
                        :tableSearch="tableGBSearch"
                        name="tableGet2"
                        @filtrar="searchsData('asesor')"
                        @limpiar="limpiarSearchs"
                        @save="saveForm"
                        >   
                        <template v-slot:filtrar>                          
                          <b-row align-v="center" style="margin-bottom:5px ;background: rgba(0, 80, 166, 0.03);border: 1px ridge;"> 
                              <sw-searchs
                                :md="4"
                                :lg="4"
                                label='Seleccionar Asesor'
                                list='datos_asesor'
                                :filter="[{campo: 'id_list_estado', value: 1}]"
                              >
                              </sw-searchs>  
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Mes Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="mesPeriodo"                   
                                    :options="lists.list_mes"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                              <b-col
                                :md="2"
                                :lg="2">
                                <b-form-group
                                  label="Año Aporte"
                                >
                                  <c-multiselect
                                    style="display:inline-block;flex: 1 1 0%; margin-bottom:15px"   
                                    v-model="anoPeriodo"                   
                                    :options="lists.list_ano"
                                    label="name"
                                    track-by="name"
                                    :allow-empty="false"
                                    placeholder="Seleccionar"
                                    >
                                  </c-multiselect>
                                </b-form-group>
                              </b-col>
                          </b-row>    
                        </template>
                        <template v-slot:modal>
                          <sw-modaleditaraportes 
                            v-if="openModal.modal.modal==='Editar'"
                            @save="saveForm"                     
                            >
                          </sw-modaleditaraportes> 
                        </template>   
                        
                      </sw-tableget>            
                    </div>
                  <!-- loading -->
                </div>             
              </b-card>              
            </validation-observer>                   
      </b-col>
    </b-row> 
    <b-modal 
      v-model="openModal.modal.value"
      :title="openModal.modal.title" 
      :header-bg-variant="'primary'"
      header-text-variant="light"
      :hide-footer="true"  
      :no-close-on-backdrop="true" 
      :hide-backdrop="!openModal.modal.loaded"
      :modal-class="{'d-none': !openModal.modal.loaded}"
      size="lg"  
      >        
        <sw-modalaportes 
          v-if="openModal.modal.modal==='Aportes'"
          @save="saveForm"                     
          >
        </sw-modalaportes>   
        <sw-modalaportesgrupal 
          :mesPeriodo="mesPeriodo.id"
          :anoPeriodo="anoPeriodo.id"
          v-if="openModal.modal.modal==='AportesCentros' || openModal.modal.modal==='AportesRazon' || openModal.modal.modal==='AportesAsesor'"
          @save="saveForm"                     
          >
        </sw-modalaportesgrupal>    
    </b-modal> 
  </section>
</template>

<script>
import indexMix  from './indexMix.js'
import storeMix  from './storeMix.js'
import tableMix  from './tableMix.js'
import saveMix  from './saveMix.js'
import saveMixins  from '@/mixings/save.js'
import SwInputs  from '@/components/forms/inputs.vue'
import SwSaveform  from '@/components/forms/saveForm.vue'
import SwTablemultiple  from '@/components/dataTable/tableMultiple.vue'
import SwTableget from '@/components/dataTable/tableGet.vue'
import SwSearchs from '@/components/forms/searchs.vue'
import SwLoading from '@/components/notification/loading.vue'
import { ValidationObserver } from 'vee-validate'
import Multiselect from 'vue-multiselect'
import VueNumeric   from '@/components/vue-numeric/vue-numeric.vue'
import SwModalaportes  from '@/components/modals/aportes.vue'
import SwModalaportesgrupal  from '@/components/modals/aportesGrupal.vue'
import SwModaleditaraportes from '@/components/modals/editarAportes.vue'

export default { 
  name: "aportes_registrar",
  mixins: [indexMix,storeMix,tableMix,saveMix,saveMixins,],
  components: {
    SwInputs,    
    SwSaveform,
    SwTablemultiple,
    SwSearchs,
    SwTableget,
    SwLoading,
    'c-multiselect': Multiselect,  
    VueNumeric,    
    SwModalaportes,
    SwModaleditaraportes,
    SwModalaportesgrupal
  }
}
</script>
<style>
.nav-tabs .nav-link.active, .nav-tabs .nav-item.show .nav-link
{
  background: #fcfcfc;
  font-weight: 500;
}
.aporteDatosAfiliado .form-group {
  margin: 0 !important;
}
</style>